import React, { useRef } from 'react'
import { useInfiniteHits, UseInfiniteHitsProps } from "react-instantsearch";
import { LeumitDoctor } from "assets/constants";
import { BaseHit, Hit } from "instantsearch.js";
import { LeumitDoctorType, MashlimDoctorType } from "types";
import { MashlimDoctorResult } from "./mashlimDoctorResult/MashlimDoctorResult"
import LeumitDoctorResult from "./leumitDoctorResult/LeumitDoctorResult";
import strings from 'assets/strings';


export default function GeoInfiniteHitsComponent(props: UseInfiniteHitsProps) {
  const { hits, showMore, isLastPage  } = useInfiniteHits(props);
  //const [nextFocusIndex, setCurrentFocusIndex] = React.useState(0);
  const doctorResultRef = useRef<HTMLDivElement>(null);

  const handleShowMore = () => {
    showMore();
    //setCurrentFocusIndex(nextFocusIndex + 20);
    doctorResultRef.current?.focus();
  }
  
  return (
    <div className='animate'>
      {hits.map((hit: Hit<BaseHit>, index) => {       
        if (hit.type === LeumitDoctor)
          return <LeumitDoctorResult hit={hit as LeumitDoctorType} key={`${hit.objectID}_${index}`} ref={ doctorResultRef }/>;
        else
          return <MashlimDoctorResult hit={hit as MashlimDoctorType} key={hit.objectID}/>;
      })
      }
      {!isLastPage && <button className='ais-InfiniteHits-loadMore' onClick={handleShowMore} disabled={isLastPage}>{strings.globalStrings.moreResults}</button>}
    </div>
  )

}
